import { useEffect } from 'react'

import { INTEGRATION_BC, INTEGRATION_MESSAGE_TYPE } from './constants'
import { getDomainPair, isSenderSide } from './integrationDomain'

// 다탭 student-up 즉시 redirect 동기
//   sender 가 SYNC_COMPLETED 받고 marker set 한 직후 BroadcastChannel 로 다른 탭들에게 알림.
//   본 hook 은 sender 측 (student-up) 의 모든 top-level 탭이 자기 origin 의 BC 를 구독해서, 알림 받으면
//   자기도 즉시 student.{root} 로 redirect (path/search/hash 보존).
export const useTransferDoneRedirect = (): void => {
  useEffect(() => {
    if (typeof BroadcastChannel === 'undefined') return // WebView 미지원

    // sender(통합 student-up) 측 탭만 구독 — receiver(통합 student) 탭은 본 hook 의 redirect 대상 아님
    if (!isSenderSide()) return

    const pair = getDomainPair()
    if (!pair) return

    let bc: BroadcastChannel
    try {
      bc = new BroadcastChannel(INTEGRATION_BC.CHANNEL)
    } catch {
      return
    }

    const handler = (event: MessageEvent) => {
      if (!event.data || typeof event.data !== 'object') return
      if (event.data.type !== INTEGRATION_MESSAGE_TYPE.BC_REDIRECT_TO_STUDENT) return

      // path/search/hash 보존 후 student.{root} 으로 redirect
      const targetUrl = new URL(
        window.location.pathname + window.location.search + window.location.hash,
        pair.iframeOrigin,
      )
      window.location.replace(targetUrl.toString())
    }

    bc.addEventListener('message', handler)
    return () => {
      bc.removeEventListener('message', handler)
      bc.close()
    }
  }, [])
}
